<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container mt-4">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-5">
      <div class="col-12">
        <div *ngIf="!editPetMissingReportId">
          <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">
            Report a pet missing
          </h1>
          <h4 class="mt-4">
            Please fill in your details so we can create your shareable missing pet report to help find {{ pet.name }}.
          </h4>
        </div>
        <div *ngIf="editPetMissingReportId">
          <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">
            Update your missing pet report
          </h1>
        </div>
      </div>
    </div>

    <div class="row mb-6">
      <div class="col-12">
        <div ngbAccordion [closeOthers]="true">
          <div ngbAccordionItem="first" #first="ngbAccordionItem" id="pet-details">
            <div ngbAccordionHeader>
              <div class="card border-0">
                <div class="card-header">
                  <div class="row">
                    <div class="col-sm-8">
                      <h4 class="mb-0">Pet details</h4>
                      <p class="text-muted mb-0">
                        Double check your pet's details
                      </p>
                    </div>
                    <div class="col-sm-4 text-end">
                      <button
                        ngbAccordionToggle
                        class="btn btn-sm mt-2"
                        [class]="{ 'btn-outline-secondary' : first.collapsed, 'btn-light': !first.collapsed }">
                        {{ !first.collapsed ? 'Hide' : 'See' }} details
                        <fa-icon [icon]="['fas', !first.collapsed ? 'caret-up' : 'caret-down']"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="row">
                    <div class="col-md-6">
                      <ul class="list-group list-group-left">
                        <li class="list-group-item">
                          <h5 class="text-primary">Chip number</h5>
                          {{ pet.chipNumber }}
                        </li>
                        <li class="list-group-item">
                          <h5 class="text-primary">Pet name</h5>
                          {{ pet.name }}
                        </li>
                        <li class="list-group-item">
                          <h5 class="text-primary">Breed</h5>
                          {{ pet.breed }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <ul class="list-group list-group-right">
                        <li class="list-group-item">
                          <h5 class="text-primary">Birth month/year</h5>
                          {{ pet.dob | date: 'MM/y' }}
                        </li>
                        <li class="list-group-item">
                          <h5 class="text-primary">Colours/markings</h5>
                          {{ pet.coloursMarkings ? pet.coloursMarkings : 'Not provided' }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12 text-end">
                      <ul class="update-links m-0">
                        <li>
                          <a
                            [routerLink]="['/my-pet', pet.id, 'edit']"
                            [queryParams]="{r: currentUrl}">
                            Update your pet details
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div ngbAccordionItem="second" #second="ngbAccordionItem" id="contact-details">
            <div ngbAccordionHeader>
              <div class="card border-0">
                <div class="card-header">
                  <div class="row">
                    <div class="col-sm-8">
                      <h4 class="mb-0">Your contact details</h4>
                      <p class="text-muted mb-0">
                        These will not be shared.
                        To find out more please find our privacy policy <a routerLink="/privacy" target="_blank">here</a>.
                      </p>
                    </div>
                    <div class="col-sm-4 text-end">
                      <button
                        ngbAccordionToggle
                        class="btn btn-sm mt-2"
                        [class]="{ 'btn-outline-secondary' : second.collapsed, 'btn-light': !second.collapsed }">
                        {{ !second.collapsed ? 'Hide' : 'See' }} details
                        <fa-icon [icon]="['fas', !second.collapsed ? 'caret-up' : 'caret-down']"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="row">
                    <div class="col-md-6">
                      <ul class="list-group list-group-left">
                        <li class="list-group-item">
                          <h5 class="text-primary">Home address</h5>
                          {{  mainAddress.line1 }}<span *ngIf="mainAddress.line2">, {{  mainAddress.line2 }}</span>
                        </li>
                        <li class="list-group-item">
                          <h5 class="text-primary">City</h5>
                          {{ mainAddress.town }}
                        </li>
                        <li class="list-group-item">
                          <h5 class="text-primary">Postcode</h5>
                          {{ mainAddress.postcode }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <ul class="list-group list-group-right">
                        <li class="list-group-item">
                          <h5 class="text-primary">Phone number</h5>
                          {{ telephones.mainPhoneNumber || 'Not provided' }}
                        </li>
                        <li class="list-group-item">
                          <h5 class="text-primary">Second phone number</h5>
                          {{ telephones.secondaryPhoneNumber || 'Not provided' }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12 text-end">
                      <ul class="update-links m-0">
                        <li *ngIf="user.productType === productType.Locator ||
                         user.productType === productType.Premium ||
                         user.productType === productType.LegacyPremium ||
                         user.productType === productType.LegacyPlus ||
                         user.productType === productType.BasicPlus">
                          <a
                            [routerLink]="['/account/address', mainAddress.id, 'edit']"
                            [queryParams]="{r: currentUrl}">
                            Update address
                          </a>
                        </li>
                        <li *ngIf="userService.isUserBasic(user.productType)">
                          Only premium members are able to update their address.
                          <a routerLink="/account/account-type">
                            Click here to upgrade.
                          </a>
                        </li>
                        <li>
                          <a
                            [routerLink]="['/account/update-telephone']"
                            [queryParams]="{r: currentUrl}">
                            Update phone numbers
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-4" />

    <div class="row mb-5">
      <div class="col-12">
        <form
          #reportMissingPetForm="ngForm"
          (ngSubmit)="submit(reportMissingPetForm)"
          novalidate>

          <div [ngClass]="{'form-card p-4': useRebrandedLayout}">
            <div class="row">
              <div class="col-12">

                <p class="text-muted mb-2 text-center">
                  Please give us some more information so we can do our very best to help reunite you with your pet.
                </p>

                <div class="row mb-4 mt-3">
                  <div class="col-12">
                    <div class="text-center mb-3">
                      <h4>Your pet's image</h4>
                      <small
                        *ngIf="!report.lastSeen.imageId"
                        class="text-danger">
                        Your pet's image is required
                      </small>
                    </div>
                    <div class="pet-image-wrapper">
                      <div
                        class="pet-image"
                        [class.is-invalid]="reportMissingPetForm.touched && !report.lastSeen.imageId"
                        [ngStyle]="petImage && {'background-image': 'url(' + petImage + ')'}"></div>
                      <div *ngIf="true" class="pet-image-add-edit">
                        <button type="button" class="btn btn-secondary text-white btn-sm" (click)="openImageUploader()">{{ petImage ? 'Edit' : 'Add' }} image</button>
                      </div>
                    </div>
                    <div class="text-center">
                      <button type="button"
                              class="btn btn-link"
                              (click)="togglePictureType()">
                        <fa-icon [icon]="['far', useDefaultPicture ? 'check-square' : 'square']"></fa-icon>
                        Use/Update default picture
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="mb-3 status-toggle">
                      <label for="status" class="d-block form-label">
                        <h4>Status</h4>
                        If you're unsure of your pet's status, please select 'missing'
                      </label>
                      <div
                        class="btn-group btn-group-toggle"
                        id="status">
                        <label
                          ngbButtonLabel
                          class="btn btn-outline-secondary form-label"
                          [ngClass]="{'active': report.reportType === petMissingReportType.Missing}"
                          >
                          <input
                            ngbButton
                            type="radio"
                            (click)="toggleReportType($event)"
                            [value]="petMissingReportType.Missing"
                             />
                          Missing
                        </label>
                        <label
                          ngbButtonLabel
                          class="btn btn-outline-secondary form-label"
                          [ngClass]="{'active': report.reportType === petMissingReportType.Stolen}"
                          >
                          <input
                            ngbButton
                            type="radio"
                            (click)="toggleReportType($event)"
                            [value]="petMissingReportType.Stolen"
                             />
                          Stolen
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <h4 class="mb-0 text-center">
                  Last seen
                </h4>
                <p class="text-muted mb-4 text-center">
                  Please add the location on the map below and add the date and time of where you last saw your pet.
                </p>

                <div class="row">
                  <div class="col-md-6">

                    <div class="mb-3">
                      <label class="form-label" for="lastSeenDate">
                        Last seen date
                      </label>
                      <div class="input-group">
                        <input
                          #lastSeenDate="ngbDatepicker"
                          #lastSeenDateModel="ngModel"
                          class="form-control"
                          [class.is-invalid]="lastSeenDateModel.invalid"
                          name="lastSeenDate"
                          [(ngModel)]="lastSeenDateValue"
                          placeholder="dd/mm/yyyy"
                          ngbDatepicker
                          [maxDate]="today"
                          [minDate]="minDate"
                          required>
                          <button
                            class="btn btn-outline-secondary calendar"
                            (click)="lastSeenDate.toggle()"
                            type="button">
                            <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                          </button>
                        <div
                          *ngIf="lastSeenDateModel.invalid && lastSeenDateModel.errors.required"
                          class="invalid-feedback">
                          {{ errorStrings.required }}
                        </div>
                        <div
                          *ngIf="lastSeenDateModel.invalid &&
                                 lastSeenDateModel.errors.ngbDate &&
                                 lastSeenDateModel.errors.ngbDate.invalid"
                          class="invalid-feedback">
                          {{ errorStrings.invalidDateForm }}
                        </div>
                        <div
                          *ngIf="lastSeenDateModel.invalid &&
                                 lastSeenDateModel.errors.ngbDate &&
                                 lastSeenDateModel.errors.ngbDate.maxDate"
                          class="invalid-feedback">
                          Please enter a date not later than today.
                        </div>
                        <div
                          *ngIf="lastSeenDateModel.invalid &&
                                 lastSeenDateModel.errors.ngbDate &&
                                 lastSeenDateModel.errors.ngbDate.minDate"
                          class="invalid-feedback">
                          Please enter a date after
                          {{ lastSeenDateModel.errors.ngbDate.minDate.minDate.day + '/' +
                             lastSeenDateModel.errors.ngbDate.minDate.minDate.month + '/' +
                             lastSeenDateModel.errors.ngbDate.minDate.minDate.year }}.
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label" for="lastSeenTime">
                        Last seen time (optional)
                      </label>
                      <ngb-timepicker
                        #lastSeenTime="ngModel"
                        id="lastSeenTime"
                        name="lastSeenTime"
                        [meridian]="true"
                        [(ngModel)]="lastSeenTimeValue"
                        [size]="'medium'"
                        [spinners]="false">
                      </ngb-timepicker>
                    </div>

                    <div class="mb-3">
                      <label class="form-label" for="lastSeenNotes">
                        Additional notes
                      </label>
                      <textarea
                        #lastSeenNotes="ngModel"
                        class="form-control"
                        [class.is-invalid]="lastSeenNotes.invalid"
                        id="lastSeenNotes"
                        name="lastSeenNotes"
                        [(ngModel)]="report.lastSeen.notes"
                        placeholder="Where did you lose them? Are they good with people or other dogs? Wearing a collar/tag/coat?"
                        required
                        rows="5">
                      </textarea>
                      <div
                        *ngIf="lastSeenNotes.invalid && lastSeenNotes.errors.required"
                        class="invalid-feedback">
                        {{ errorStrings.required }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label" for="lastSeenDate">
                        Last seen location
                      </label>
                      <div
                        class="map-field form-control">
                        <google-map
                          *ngIf="mapsReady"
                          [zoom]="report.lastSeen.location.latitude && report.lastSeen.location.longitude ? 14 : 5"
                          [center]="{
                            lat: report.lastSeen.location.latitude || 54.11815748515591,
                            lng: report.lastSeen.location.longitude || -2.541813085952347
                          }"
                          [options]="mapOptions"
                          width="100%"
                          >
                          <!-- [latitude]="report.lastSeen.location.latitude || 54.11815748515591"
                          [longitude]="report.lastSeen.location.longitude || -2.541813085952347" -->
                          <map-circle
                            *ngIf="report.lastSeen.location.latitude && report.lastSeen.location.longitude"
                            [center]="{
                              lat: report.lastSeen.location.latitude,
                              lng: report.lastSeen.location.longitude
                            }"
                            [radius]="250"
                            [options]="circleOptions">
                          </map-circle>
                      
                        </google-map>
                        <button
                          type="button"
                          (click)="openMap()"
                          [disabled]="!mapsReady"
                          class="btn btn-secondary text-white">
                          {{
                            !report.lastSeen.location.latitude || !report.lastSeen.location.longitude
                            ? 'Add location'
                            : 'Edit/View'
                          }}
                        </button>
                      </div>
                      <div class="invalid-feedback">
                        The last seen location is required. Please add a location.
                      </div>
                    </div>
                  </div>
                </div>
                <hr *ngIf="!useRebrandedLayout" class="my-4" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 offset-md-4 mb-3">
              <button
                type="submit"
                class="btn btn-success text-white btn-lg w-100 mt-5"
                [disabled]="!reportMissingPetForm.valid ||
                            loading ||
                            !report.lastSeen.location.latitude ||
                            !report.lastSeen.location.longitude ||
                            !report.lastSeen.imageId">
                <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
                {{ loading ? 'Saving...' : 'Submit' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a *ngIf="!editPetMissingReportId" [routerLink]="['/my-pet', pet.id]">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to pet profile
        </a>
        <a *ngIf="editPetMissingReportId" [routerLink]="['/lost-and-found', 'missing-pet', editPetMissingReportId]">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to missing pet report
        </a>
      </div>
    </div>
  </div>
</div>
